import { GetterTree } from 'vuex';
import { ProjectComplet, StateInterface } from '@/interfaces/projects';


const getters: GetterTree<ProjectComplet, StateInterface> = {
    // someGetter( /* state */ ) {
    //     // return true;
    // },
    // projectId(state) {
    //     return state.projectId;
    // },
    // getEntriesByTerm ( state ) => ( term = '' ) => {

    //     if ( term.length === 0 ) return state.projects
    
    //     return state.entries.filter( entry => entry.text.toLowerCase().includes( term.toLocaleLowerCase() ) )
    // }
    getProjectId( state ) {
        return state.project.id_proyecto;
    },
    getProjectName( state ) {
        return state.project.nombre;
    },
    getProjectDescription( state ) {
        return state.project.descripcion;
    },

    getClientId( state ) {
        return state.client.id_cliente;
    },
    getClientName( state ) {
        return state.client.nombre;
    },

    getReview( state ) {
        return state.review;
    },
    getTotal( state ) {
        return state.total;
    },

    getCurrentDate( state ) {
        return state.currentDate;
    },
    getReviewPending( state ) {
        return state.reviewPending;
    },
    getNewDocsToday( state ) {
        return state.newDocsToday;
    },
    getPrioritario( state ) {
        return state.prioritario;
    },
    getReviewedToday( state ) {
        return state.reviewedToday;
    },
    getDocuments( state ) {
        return state.documents;
    },
    getDocTypesList: (state) => {
        return [{
            groupName:"Todos los Documentos",
            documentTypes:state.documents,
        }]; 
      },
}



export default getters;